import React from "react";
import { connect } from "react-redux";

import {
  mapStateToProps,
  mapDispatchToProps,
  HomeContainer
} from "components/Home/HomeContainer";
import HomePage from "./HomePage";

class LosDesafiosHomeContainer extends HomeContainer {
  render() {
    return (
      <HomePage
        handleKeyPress={this.handleKeyPress}
        handleSearchChange={this.handleSearchChange}
        handleSubmit={this.handleSubmit}
        language={this.props.language}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LosDesafiosHomeContainer);
